import httpClient from '../httpClient';

const post = async (data) => {
	return await httpClient.post(`${process.env.REACT_APP_API_HOST}/currency_types/`, data);
};

const getAll = async () => {
  return await httpClient.get(`${process.env.REACT_APP_API_HOST}/currency_types/`);
};

const get = async (id) => {
  return await httpClient.get(`${process.env.REACT_APP_API_HOST}/currency_types/${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`${process.env.REACT_APP_API_HOST}/currency_types/${id}/`, data);
};

const patch = async (id) => {
  return await httpClient.patch(`${process.env.REACT_APP_API_HOST}/currency_types/${id}`);
};

const remove = async (id) => {
  return await httpClient.delete(`${process.env.REACT_APP_API_HOST}/currency_types/${id}`);
};

export {
  post,
  getAll,
  get,
  put,
  remove
}

